// noinspection IfStatementWithTooManyBranchesJS,NegatedIfStatementJS

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

// noinspection OverlyComplexFunctionJS,FunctionWithMoreThanThreeNegationsJS
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  searchValue: any;
  searchRes: any;
  @Input() data: any;
  @Input() type: string;
  @Output() searchResult = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }
  getValue(event): any {
    this.searchValue = event.target.value;
    let result = [];
    if (event.target.value !== '') {
      if (this.type?.toLowerCase().indexOf('user') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.userName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
            item.userPhone1?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      } else if (this.type?.toLowerCase().indexOf('ledger') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.userNameX1?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      } else if (this.type?.toLowerCase().indexOf('revenue') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.clusterName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
            item.stationName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      } else if (this.type?.toLowerCase().indexOf('float') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.stationNameX1?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      } else if (this.type?.toLowerCase().indexOf('taxi stages') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.taxiStageName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      }
      else if (this.type?.toLowerCase().indexOf('boda stages') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.bodabodaStageName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      } else if (this.type?.toLowerCase().indexOf('cluster') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.clusterName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      } else if (this.type?.toLowerCase().indexOf('park') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.taxiParkName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      } else if (this.type?.toLowerCase().indexOf('loan') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.customerName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
            item.customerPhone1?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      } else if (this.type?.toLowerCase().indexOf('security') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.customerName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
            item.theSecurityName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
            item.securityTypeName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
            item.customerPhone1?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      } else if (this.type?.toLowerCase().indexOf('guarantor') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.customerName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
            item.gaurantorName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
            item.customerPhone1?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      } else if (this.type?.toLowerCase().indexOf('client') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.customerName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
            item.customerPhone1?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      } else if (this.type?.toLowerCase().indexOf('station') !== -1) {
        result = this.data?.filter(
          (item) =>
            item.stationName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      } else {
        result = this.data?.filter(
          (item) =>
            item.customerName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
            item.customerPhone1?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
        );
      }
    } else {
      result = this.data;
    }
    // result = this.reports?.filter(
    //   (item) =>
    //     item.userName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.customerName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.userNameX1?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.gaurantorName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.theSecurityName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.customerIdType?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.clusterName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.bodabodaStageName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.customerPhone1?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.stationNameX1?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.stationName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.securityTypeName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.taxiParkName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.taxiStageName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1 ||
    //     item.bodabodaStageChairmanName?.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1
    // )
    this.searchResult.emit(result);
  }
}
